import * as z from "zod";

export const MarketingPermission = {
  MARKETING_ADMIN: "marketing_admin",
  FLAGGED_TAB_ACCESS: "flagged_tab_access",
  SEND_EDITED_MESSAGES: "send_edited_messages",
  SEND_MANUAL_MESSAGES: "send_manual_messages",
  RETURNS_QUEUE_ACCESS: "returns_queue_access",
  DEDICATED_QUEUE_ACCESS: "dedicated_queue_access",
} as const;

export const MARKETING_PERMISSION_OPTIONS = [
  MarketingPermission.MARKETING_ADMIN,
  MarketingPermission.FLAGGED_TAB_ACCESS,
  MarketingPermission.SEND_EDITED_MESSAGES,
  MarketingPermission.SEND_MANUAL_MESSAGES,
  MarketingPermission.RETURNS_QUEUE_ACCESS,
  MarketingPermission.DEDICATED_QUEUE_ACCESS,
] as const;

export const marketingPermissionSchema = z.enum(MARKETING_PERMISSION_OPTIONS);

export type MarketingPermission = z.infer<typeof marketingPermissionSchema>;

export function canonicalizeMarketingPermissions(
  permissions: readonly MarketingPermission[],
): MarketingPermission[] {
  if (permissions.includes(MarketingPermission.MARKETING_ADMIN)) {
    return [MarketingPermission.MARKETING_ADMIN];
  }
  return MARKETING_PERMISSION_OPTIONS.filter((permission) =>
    permissions.includes(permission),
  );
}

export function hasMarketingPermission(
  permissions: readonly MarketingPermission[],
  permission: MarketingPermission,
): boolean {
  return permissions.includes(permission);
}
